import {  combineReducers } from '@reduxjs/toolkit'

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { encryptTransform } from 'redux-persist-transform-encrypt';

import auth from "./auth";
import timeouts from "./auth_timeout";
import message from "./message";
import viewinstance from "./viewinstance";

import pwresetReducer from "./pwreset";
import pwrequestReducer from "./pwrequest";

import terms from "./terms";
import surveyReducer from "./survey"
import sectionReducer from "./survey_section"
import questionsetReducer from "./survey_questionset"
import questionReducer from "./survey_question"

import articleReducer from "./healthshelf_article"
import topicReducer from "./healthshelf_topic"
import hsfilterReducer from "./healthshelf_filter"
import healthshelfReducer from "./healthshelf_single"

import adminparticipantReducer from "./admincenter_participants"
import reportcriteriaReducer from "./admincenter_reportcriteria"
import datareportReducer from "./admincenter_datareport"
import uireportReducer from "./admincenter_uireport"
import admingroupsReducer from "./admincenter_groups"
import participantdemographicsReducer from "./admincenter_participantdemographics"
import participantaddressReducer from "./admincenter_participantaddress"
import participantphoneReducer from "./admincenter_participantphone"
import participantmiscReducer from "./admincenter_participantmisc"
import participantinviteReducer from "./admincenter_participantinvite"
import participantpasswordReducer from "./admincenter_participantpassword"
import participantmergeReducer from "./admincenter_participantmerge"
import participantmoveReducer from "./admincenter_participantmove"

import participantBiometrics from "./admincenter_biometrics"
import participantResponses from "./admincenter_responses"

import clientlogoReducer from './reference_clientlogo'
import navmenuReducer from './reference_navmenu'
import termsAndConditionsReducer from './terms_and_conditions'
import privacypolicyReducer from './privacy_policy'

import spokenlanguageReducer from './reference_spokenlanguage'
import countryReducer from './reference_country'
import educationReducer from './reference_education'
import phonetypeReducer from './reference_phonetype'
import addresstypeReducer from './reference_addresstypes'
import misctypeReducer from './reference_misctypes'
import errormessageReducer from './reference_errormessages'
import birthsexReducer from './reference_birthsex'
import raceReducer from './reference_race'
import profileviReducer from './reference_profilevi'

import interactionReducer from './interaction'

import viewinstancesReducer from './reuseable_vi'
import globalsettingsReducer from './reference_settings'



import reportproductReducer from './reference_reportproduct'

import contextsReducer from './global_contexts'

// import calcsReducer from './survey_calc'
// import translationsReducer from './reference_translations'

const reducersToPersist = ['auths','auth', 'globalsettings']
const persistConfig = {
  key: 'root',
  storage,
  transforms: [
    encryptTransform({
      secretKey: 'W#llS0urCe R3duXxX',
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
  whitelist: reducersToPersist
};


//
// saving this in case we need to persist smaller sections of a 'slice'
//
// we add an additional config, and keep the persistConfig from above (its root)
//
const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['isLoggedIn']
}
//
//
// then tie this additional configuration to the reducer so we can make sure its never saved.
//
// const rootReducers = combineReducers({
//   user: persistReducer(authPersistConfig, authReducer),
// })
//
//

export const rootReducers = combineReducers({
  auth,
  message,
  viewinstance,
  terms,
  timeouts:timeouts,
  pwreset: pwresetReducer,
  pwrequest:pwrequestReducer,

  surveys: surveyReducer,
  sections: sectionReducer,
  questionsets: questionsetReducer,
  questions:questionReducer,


  topics:topicReducer,
  articles:articleReducer,
  hsfilters:hsfilterReducer,
  healthshelfs:healthshelfReducer,

  adminparticipants: adminparticipantReducer,
  reportcriterias:reportcriteriaReducer,
  datareports: datareportReducer,
  uireports: uireportReducer,
  admingroups:admingroupsReducer,
  reportproducts:reportproductReducer,

  participantdemographics: participantdemographicsReducer,
  participantaddresss: participantaddressReducer,
  participantphones: participantphoneReducer,
  participantmiscs: participantmiscReducer,

  participantinvites: participantinviteReducer,
  participantpasswords: participantpasswordReducer,
  participantmoves: participantmoveReducer,
  participantmerges: participantmergeReducer,

  participantbiometrics: participantBiometrics,
  participantresponses: participantResponses,


  clientlogo:clientlogoReducer,
  navmenu:navmenuReducer,
  termsandconditions: termsAndConditionsReducer,
  privacypolicy: privacypolicyReducer,

  spokenlanguages: spokenlanguageReducer,
  countrys: countryReducer,
  educations: educationReducer,
  phonetypes: phonetypeReducer,
  addresstypes: addresstypeReducer,
  misctypes: misctypeReducer,
  birthsexs: birthsexReducer,
  races: raceReducer,
  
  profilevis: profileviReducer,


  errormessages: errormessageReducer,

  contexts: contextsReducer,

  interactions:interactionReducer,
  viewinstances: viewinstancesReducer,
  globalsettings: globalsettingsReducer,
  // translations: translationsReducer,
  //   calcs:calcsReducer,

});

const persistedReducer = persistReducer(persistConfig, rootReducers);


export default persistedReducer